import mitt from 'mitt'
import { EVENTS } from '@/lib/consts.js'

const emitter = mitt()

const validate = (name) => {
  if (!Object.values(EVENTS).includes(name)) {
    throw new Error(`Event \`${name}\` not registered!`)
  }
}

const emitterApi = {
  on: (name, handler) => {
    validate(name)
    emitter.on(name, handler)
  },

  off: (name, event) => {
    emitter.off(name, event)
  },

  emit: (name, arg) => {
    validate(name)
    emitter.emit(name, arg)
  },

  EVENTS,
}

export const useEmitter = () => {
  return emitterApi
}
